import { startOfWeek } from 'date-fns';
import i18next from 'i18next';
import * as storage from './storage';
import { encryption } from './encryption';
import moment from "moment";
import { IsEnglish } from './language';
import axios from "axios";

export function format(str, ...args)
{
    return str.replace(/{(\d+)}/g, (m, i) => args[i] ?? m);
}

export function formatNumber(number, size, character) {
    character = character || '0';
    number = number + '';
    return number.length >= size ? number : new Array(size - number.length + 1).join(character) + number;
}

export function convertToDate(date) {
    if (date === undefined) {
        return null;
    }

    const formattedDate = formatCharactersDate(date);

    const myDate = new Date(formattedDate);

    return myDate;
}

export function formatDate(date, type, character) {
    if (date === undefined) {
        return null;
    }

    const formattedDate = formatCharactersDate(date);

    const myDate = new Date(formattedDate);

    const year = myDate.getFullYear();
    const month = myDate.getMonth() + 1;
    const day = myDate.getDate();
    const hour = myDate.getHours();
    const minute = myDate.getMinutes();

    if (character === undefined) {
        character = '-';
    }

    if (isNaN(year)) {
        return null;
    }

    if (type === 'date') {
        return `${year}${character}${formatNumber(month, 2)}${character}${formatNumber(day, 2)}`;
    }
    else if (type === 'time') {
        return `${formatNumber(hour, 2)}:${formatNumber(minute, 2)}`;
    }
    else {
        return `${year}${character}${formatNumber(month, 2)}${character}${formatNumber(day, 2)} ${formatNumber(hour, 2)}:${formatNumber(minute, 2)}`;
    }
}

export function formatCharactersDate(date) {

    if (isNullOrEmpty(date)) {
        return;
    }

    if (date == undefined) {
        return;
    }

    if (typeof date == 'string') {
        if ((date.split(':')).length <= 1) {
            date = date + ' 00:00';
        }
        date = date.replace('T', ' ').replace('Z', ' ').replace('.', '');
        var arr = date.split(/[- :]/);
        date = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4]);
    }

    if (typeof date !== 'object') {
        return;
    }

    date = date.toLocaleDateString('fr-ca').split('/').reverse().join('-') + ' ' + date.toTimeString().split(' ')[0];

    const index = date.lastIndexOf('.');
    const formattedDate = index > -1 ? date.substring(0, index) : date;

    return formattedDate.replace(/-/g, '\/').replace('T', ' ').replace('Z', ' ').replace('.', '');
}

export function formatTime(time) {
    if (time.length == 4) {
        const timeFormated = `${time.substring(0, 2)}:${time.substring(2)}`;

        return timeFormated;
    }

    return time;
}


export function formatDateTimeNET(date) {
    // The date must be in this format "{date} {time}". Ex.2022-10-18 08:00
    return date.replace(' ', 'T');
}

export function isLoginPage() {
    const page = window.location.pathname;

    return page.indexOf('/login/') >= 0
}

export function getFirstDayWeek(d, startWeekDay) {
    const firstDay = startOfWeek(d, { weekStartsOn: startWeekDay });

    return firstDay;
}

export function getFirstLastDayWeek(d, startWeekDay) {
    const firstDay = getFirstDayWeek(d, startWeekDay);
    const lastDay = new Date(firstDay);
    lastDay.setDate(firstDay.getDate() + 6);

    return { firstDay: formatDate(firstDay.toISOString(), 'date'), lastDay: formatDate(lastDay.toISOString(), 'date') };
}

export function AddDays(date, days) {
    date = new Date(formatCharactersDate(date));
    const day = new Date(date);
    day.setDate(date.getDate() + days);

    return day;
}

export function RemoveDays(date, days) {
    date = new Date(formatCharactersDate(date));
    const day = new Date(date);
    day.setDate(date.getDate() - days);

    return day;
}

export function timeDiffCalc(dateFuture, dateNow) {
    let diffInMilliSeconds = Math.abs(dateFuture - dateNow) / 1000;

    // calculate days
    //const days = Math.floor(diffInMilliSeconds / 86400);
    //diffInMilliSeconds -= days * 86400;
    //console.log('calculated days', days);

    // calculate hours
    const hours = Math.floor(diffInMilliSeconds / 3600) % 24;
    diffInMilliSeconds -= hours * 3600;
    //console.log('calculated hours', hours);

    // calculate minutes
    const minutes = Math.floor(diffInMilliSeconds / 60) % 60;
    diffInMilliSeconds -= minutes * 60;
    //console.log('minutes', minutes);

    return { hour: formatNumber(hours, 2), minute: formatNumber(minutes, 2) };
}

export function timeDiffCalcDecimal(dateFuture, dateNow) {
    let diffInMilliSeconds = Math.abs(dateFuture - dateNow) / 1000;

    const diffTime = diffInMilliSeconds / 60 / 60;

    return diffTime;
}

export function getWeekDay(date) {
    const weekDay = new Date(date).getDay();

    return weekDay;
}

export function decimalSeparator() {
    const n = IsEnglish() ? '.' : ',';

    return n;
}

export function encryptPassword(password) {
    var crypto = require('jscrypto')

    const tt = storage.getClientHashKey();
    var hash = crypto.SHA1.hash(`${password}.${storage.getClientHashKey()}`)
    var firstLevelPassword = hash.toString();

    return encryption(firstLevelPassword);
}

export function toISOTimezone(date) {
    const tzoffset = (new Date(date)).getTimezoneOffset() * 60000; //offset in milliseconds
    const localISOTime = (new Date(date - tzoffset)).toISOString().slice(0, -1);

    return localISOTime;
}

export function getDescriptionWeekDay(date, lowerCase) {
    const weekDay = getWeekDay(date);

    let weekday = new Array(7);
    weekday[0] = `${i18next.t("weekday:week.sunday")}`;
    weekday[1] = `${i18next.t("weekday:week.monday")}`;
    weekday[2] = `${i18next.t("weekday:week.tuesday")}`;
    weekday[3] = `${i18next.t("weekday:week.wednesday")}`;
    weekday[4] = `${i18next.t("weekday:week.thursday")}`;
    weekday[5] = `${i18next.t("weekday:week.friday")}`;
    weekday[6] = `${i18next.t("weekday:week.saturday")}`;

    let descriptionWeekDay = weekday[weekDay];

    if (lowerCase === true) {
        descriptionWeekDay = descriptionWeekDay.toLowerCase();
    }

    return descriptionWeekDay;
}

export function toPhone(value) {
    if (value == null) {
        return;
    }

    let phoneNumberFormat = value.replace(/[^A-Z0-9]/ig, "");//remove all special characters and spaces

    if (phoneNumberFormat.length > 10) {
        return phoneNumberFormat.replace(/^(\d{3})(\d{3})(\d{4})(.*)/, "$1 $2-$3 $4");
    }

    return phoneNumberFormat.replace(/^(\d{3})(\d{3})(\d{4})/, "$1 $2-$3");
};

export function toPostalCode(value) {
    if (value == null) {
        return;
    }

    let formatted = value.replace(/^(\w{3})(\w{3})(.*)/, "$1 $2$3");

    return formatted.toUpperCase();
};

export function formatPostalCode(value) {
    // Keep only letters/digits, uppercase
    const raw = value.toUpperCase().replace(/[^A-Z0-9]/g, '');

    let result = '';
    for (const char of raw) {
        const pos = result.length; // position in "A0A0A0" (no space yet)
        if (pos >= 6) break;

        const expectLetter = pos % 2 === 0; // positions 0,2,4 = letters
        if (expectLetter && /[A-Z]/.test(char)) {
            result += char;
        } else if (!expectLetter && /[0-9]/.test(char)) {
            result += char;
        }
        // invalid char for this position → skipped
    }

    // Insert the space after the 3rd character
    return result.length > 3
        ? result.slice(0, 3) + ' ' + result.slice(3)
        : result;
};


export function cleanData(value) {
    if (value == null) {
        return;
    }

    let formatted = value.replace(' ', '').replace('-', '');

    return formatted;
}

export function toEmpty(value) {
    if (value == null) {
        return '';
    }
    return value.trim();
}

export function isEmpty(value) {
    if (value == null || value.toString().trim().length == 0) {
        return true;
    }
    return false;
}

/**
 * Function returning the build date(as per provided epoch)
 * @param epoch Time in milliseconds
 */
export const getBuildDate = (epoch) => {
    const buildDate = moment(epoch).format("DD-MM-YY HH:MM");
    return buildDate;
};

export function toDisplayDecimal(value, digits = 2, showDollarSign = false) {
    if (value === null || value === undefined) {
        return null;
    }

    let formattedValue = value.toLocaleString(IsEnglish() ? 'en-CA' : 'fr-CA', {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
    });

    if (showDollarSign === true) {
        formattedValue = displayDollarSign(formattedValue);
    }

    return formattedValue;
}

export function toDecimal(value) {
    const formattedValue = value?.toString()?.replace(',', '.');
    return !isNaN(parseFloat(formattedValue)) ? parseFloat(formattedValue) : null;
}

export function displayDollarSign(value) {
    if (IsEnglish()) {
        return `$${value}`
    }

    return `${value} $`
}

export function stringToBoolean(value, defaultValue = false) {
    if (value == null || value == '') {
        return defaultValue;
    }

    return value.toLowerCase() === 'true';
}

export function parseBool(value, defaultValue = false) {

    if (value === true || value === false) {
        return value;
    } else if (!value) {
        return defaultValue;
    }

    return value.toLowerCase() === 'true' || value.toLowerCase() === 'o' || value.toLowerCase() === '1';
}

export function isValidPhone(value) {
    return cleanData(value).length === 10;
}

export function isValidEmail(value) {
    var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    const isValid = value.match(validRegex) != null;

    return isValid;
}

export function getDayAbbrUpper(date, isEnglish) {
    const dayNamesFr = ["DIM.", "LUN.", "MAR.", "MER.", "JEU.", "VEN.", "SAM."];
    const dayNamesEn = ["SUN.", "MON.", "TUE.", "WED.", "THU.", "FRI.", "SAT."];

    if (isEnglish) {
        return dayNamesEn[(new Date(date)).getDay()];
    }

    return dayNamesFr[(new Date(date)).getDay()];
}

export function getDayAbbr(date, isEnglish) {
    const dayNamesFr = ["Dim.", "Lun.", "Mar.", "Mer.", "Jeu.", "Ven.", "Sam."];
    const dayNamesEn = ["Sun.", "Mon.", "Tue.", "Wed.", "Thu.", "Fri.", "Sat."];

    if (isEnglish) {
        return dayNamesEn[(new Date(date)).getDay()];
    }

    return dayNamesFr[(new Date(date)).getDay()];
}

export function getMonthAbbrUpper(date, isEnglish) {
    const monthNamesEn = ["JAN.", "FEB.", "MAR.", "APR.", "MAY", "JUN.", "JUL.", "AUG.", "SEP.", "OCT.", "NOV.", "DEC."];
    const monthNamesFr = ["JANV.", "FÉVR.", "MARS", "AVR", "MAI", "JUIN", "JUILL.", "AOÛT", "SEPT.", "OCT.", "NOV.", "DÉC."];

    if (isEnglish) {
        return monthNamesEn[(new Date(date)).getMonth()];
    }

    return monthNamesFr[(new Date(date)).getMonth()];
}

export function getMonthAbbr(date, isEnglish) {
    const monthNamesEn = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const monthNamesFr = ["Janv.", "Févr.", "Mars", "Avr", "Mai", "Juin", "Juill.", "Août", "Sept.", "Oct.", "Nov.", "Déc."];

    if (isEnglish) {
        return monthNamesEn[(new Date(date)).getMonth()];
    }

    return monthNamesFr[(new Date(date)).getMonth()];
}

export function getMonth(date, isEnglish) {
    const monthNamesEn = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const monthNamesFr = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];

    if (isEnglish) {
        return monthNamesEn[(new Date(date)).getMonth()];
    }

    return monthNamesFr[(new Date(date)).getMonth()];
}

export function capitalizeFirstLetter(value) {
    if (!value) {
        return "";
    }
    return value.charAt(0).toUpperCase() + value.slice(1);
}

export async function getIP() {
    const res = await axios.get("https://api.ipify.org/?format=json");
    return res.data.ip;
}

export function isIOS() {
    return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
    ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

export function resizeComponent(headerSelector, detailSelector, appBarSelector = null, offSet = 45,timeout = 1000) {
    setTimeout(function () {
        const height = window.innerHeight;
        const titleBar = appBarSelector ? document.querySelector(appBarSelector).clientHeight : 0;
        const header = document.querySelector(headerSelector).offsetHeight;

        const customHeight = height - header - titleBar - offSet;

        document.querySelector(detailSelector).style.height = `${customHeight}px`;
        document.querySelector(detailSelector).style.overflowX = 'hidden';
    }, timeout);
}

export function isSmallerThanScreenX(width) {
    return window.innerWidth < width;
}

export function unique_values(array_object, property) {

    if (array_object != null && array_object.length > 0) {
        if (property in array_object[0]) {
            let unique_values = [
                ...new Set(array_object.map((element) => element[property])),
            ];
            return unique_values;
        }
    }

    return [];
}

export function addPad(val, iPad = 2, padValue = "0", direction = 'Left') {

    if (!isNaN(parseInt(val))) {

        let newVal = '';
        let valueLength = val.toString().length;

        if (valueLength <= iPad) {

            if (direction !== 'Left') {
                newVal = val;
            }

            for (let i = 1; i <= (iPad - valueLength); i++) {
                newVal += padValue;
            }

            if (direction === 'Left') {
                newVal += val;
            }

            return newVal;
        }
    }

    return val;
}

// This function will return the user code without the super/
export function getCleanSuperUser(superUser) {
    if (superUser.toLowerCase().startsWith('super/')) {
        return superUser.toLowerCase().replace('super/', '');
    }

    return superUser;
}

export function getConnectionStringNamePrefix(listDB, userCode) {
    if (listDB.length > 0) {
        let connectionName = null;
        listDB.some(obj => {
            if (getCleanSuperUser(userCode).startsWith(obj.prefix)) {
                connectionName = obj.name;
                return true;
            }
        });

        return connectionName;
    }

    return null;
}

export function formatTimestamp(date) {
    const today = new Date();
    date = new Date(date);

    const sameDay =
        today.getFullYear() === date.getFullYear() &&
        today.getMonth() === date.getMonth() &&
        today.getDate() === date.getDate();

    if (sameDay) {
        const options = {
            hour12: false,
            hour: '2-digit',
            minute: '2-digit',
            //second: '2-digit'
        };
        const timeString = date.toLocaleTimeString(undefined, options);
        return timeString;
    } else {
        const options = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        };
        const dateTimeString = date.toLocaleString(undefined, options);
        return dateTimeString;
    }
}

export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function isNullOrEmpty(value) {
    if (typeof value === 'string') {
        return value.trim() === '';
    }
    return value === null || value === undefined;
}

export function toLocalDate(date) {
    if (isNullOrEmpty(date) || date == 'Invalid Date') {
        return null;
    }

    return convertToDate(date);
}

export function toISOLocal(date) {
    if (isNullOrEmpty(date) || date == 'Invalid Date') {
        return null;
    }

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    const milliseconds = date.getMilliseconds().toString().padStart(3, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
}

// This function will calculate the best contrast color of a text depending on a background color
export function getContrastColor(inputColor) {
    // Resolve any CSS color format (named, hex, hsl, rgb...) to rgb()
    const resolved = resolveColor(inputColor);

    const [r, g, b] = resolved.match(/\d+/g).map(Number);

    const toLinear = (c) => {
        const s = c / 255;
        return s <= 0.04045 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
    };

    const luminance = 0.2126 * toLinear(r) + 0.7152 * toLinear(g) + 0.0722 * toLinear(b);

    return luminance < 0.35 ? '#ffffff' : '#000000';
}

function resolveColor(inputColor) {
    // Create a temporary element and let the browser parse any CSS color
    const temp = document.createElement('div');
    temp.style.color = inputColor;
    document.body.appendChild(temp);
    const computed = getComputedStyle(temp).color; // Always returns rgb(...)
    document.body.removeChild(temp);
    return computed;
}